<div>Base Editor Component</div>
